import type { Lane } from "./types.js";
import { hostingBadge, premiumBadge } from "./format.js";

function Badge({ children }: { children: string }) {
  return (
    <span
      className="rounded-[var(--radius-pill)] border px-1.5 py-px text-[10px] uppercase tracking-wider"
      style={{
        borderColor: "var(--border-subtle)",
        color: "var(--text-tertiary)",
        fontFamily: "var(--font-mono)",
      }}
    >
      {children}
    </span>
  );
}

/** Hosting badge (`US` / `global`) plus the `×1.5` price badge on Fireworks US. */
export function LaneBadges({ lane }: { lane: Lane }) {
  const premium = premiumBadge(lane);
  return (
    <>
      <Badge>{hostingBadge(lane)}</Badge>
      {premium && <Badge>{premium}</Badge>}
    </>
  );
}
